import styled from 'styled-components'
import SearchBarChip from '@/components/Ads/SearchBar/SearchBarChip'
import useCategoryResizer from '@/hooks/useCategoryResizer'
import { AdsChip } from '@/components/Ads/SearchBar/SearchBarStyled'

const HeaderChips = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

const HiddenBlock = styled(AdsChip)`
  visibility: hidden;
  position: absolute;
  white-space: nowrap;
  padding-right: 28px;
`

const OverflowIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  color: rgba(21, 21, 31, 1);
  border-radius: 16px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin-left: auto;
`

const SearchBarHeaderChips = ({ chips = [], onDelete }) => {
  const { visibleChipsCount, hiddenChipsCount, measurementRef, containerRef } =
    useCategoryResizer({
      chips,
      value: 'value',
    })

  if (!chips.length) return

  return (
    <HeaderChips ref={containerRef}>
      {chips.slice(0, visibleChipsCount).map((item) => (
        <SearchBarChip
          key={item.value}
          chip={item}
          text="value"
          isDeleted
          onDelete={onDelete}
        />
      ))}
      {hiddenChipsCount > 0 && (
        <OverflowIndicator>+{hiddenChipsCount}</OverflowIndicator>
      )}
      <HiddenBlock ref={measurementRef} />
    </HeaderChips>
  )
}

export default SearchBarHeaderChips
